
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Session } from "@supabase/supabase-js";
import { SchoolUser } from "@/types/users";

export function useClientInfo(session: Session | null) {
  const [clientLogo, setClientLogo] = useState<string | null>(null);
  const [clientName, setClientName] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [schoolUser, setSchoolUser] = useState<SchoolUser | null>(null);

  useEffect(() => {
    const fetchClientInfo = async () => {
      if (!session?.user?.email) {
        setLoading(false);
        return;
      }

      try {
        const { data: schoolUserData, error: schoolUserError } = await supabase
          .from('school_users')
          .select('*')
          .eq('email', session.user.email)
          .maybeSingle();

        if (schoolUserError) throw schoolUserError;

        if (schoolUserData) {
          setSchoolUser(schoolUserData);
          
          // Set the client logo using the school ID
          if (schoolUserData.school_id) {
            setClientLogo(`https://idn-static-assets.s3-ap-southeast-1.amazonaws.com/school/${schoolUserData.school_id}.png`);
          }

          const { data: client, error: clientError } = await supabase
            .from('clients')
            .select('nama_sekolah')
            .eq('school_id', schoolUserData.school_id)
            .maybeSingle();

          if (clientError) throw clientError;

          if (client) {
            setClientName(client.nama_sekolah);
          }
        }
      } catch (error) {
        console.error('Error fetching client info:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchClientInfo();
  }, [session]);

  return { clientLogo, clientName, loading, schoolUser };
}
